<div class="mainActionViewWrapper">
    <div class="mainActionViewContent">
        <div class="actionViewHeader">
            @if (mainActionViewConfig()?.showLayers) {
                <div class = "headerTextOuterWrapper" (click)="selectLayerSelectorActionViewItem()">
                    <div class="headerTextInnerWrapper">
                        <span>{{selText.maps}}</span>
                    </div>
                </div>
            }
            @if (mainActionViewConfig()?.showSearch) {
                <app-search-box
                    class="density-5 mainSearchBoxWrapper"
                    [selText]="selText"
                    (searchTextChanged)="searchChange($event)"
                    (searchButtonClicked)="searchChange($event)"
                    [searchText]="searchText()"
                    [placeholderText]="selText.search"
                    [showButton]="false"
                >
                </app-search-box> <!--[searchText]="searchStringsCache[this.currentlySelectedActionViewItem?.originalData?.metadataLayer.id]"-->
            }
        </div>
        
        <div class="actionViewMenu">
            @if(isActionViewLoading() && mainActionViewService.actionViewItems().length < 2) {
                <div class="spinnerWrapper">
                    <mat-spinner></mat-spinner>
                </div>
            }
            @for (actionViewItem of mainActionViewService.actionViewItems(); track actionViewItem) {
                @if (!actionViewItem?.hidden) {
                    <div (click)="selectActionViewItem(actionViewItem)" class="actionViewItem" [class.selectedActionViewItem]="actionViewItem === currentlySelectedActionViewItem">
                    @if (actionViewItem.type === ActionViewItemType.search || actionViewItem.type === ActionViewItemType.layerSearch) {
                        <mat-icon style="font-size: 1.3em;" width="18" height="18" title="search">search</mat-icon>
                    }
                    <span>{{actionViewItem.text}}</span>
                    @if (actionViewItem?.closeable !== false) {
                    <mat-icon style="margin-top: 2px; margin-left: 10px;"
                        (click)="closeActionViewItem(actionViewItem, true)">close</mat-icon>
                    }
                    </div>
                }
            
            }
            @if(isActionViewLoading() && mainActionViewService.actionViewItems().length > 1) {
                <div class="spinnerWrapper remainingSpinner">
                <mat-spinner></mat-spinner>
                </div>
            }
        </div>

        <div class="seperatorWrapper">
            <div class="seperator"></div>
        </div>

        @if (currentViewState === ViewState.search) {
            @defer (on immediate) {
                <app-search
                    [selText]="selText"
                    [lang]="lang"
                    [applicationSettings]="applicationSettings()"
                    [searchText]="searchText()"
                    style="display: contents;"
                >
                </app-search>
            }
        }
        @if (currentViewState === ViewState.featureSelection) {
            @defer (on immediate) {
                <app-feature-list 
                    [featureList]="currentlySelectedActionViewItem?.formattedData?.features ?? null"
                    [selText]="selText"
                    [lang]="lang"
                    [layer]="currentlySelectedActionViewItem?.originalData?.metadataLayer"
                    [showFeatureImmediately]="showFeatureImmediately()"
                    style="display: contents;"
                >
                </app-feature-list>
            }
        }
       
        @if (currentViewState === ViewState.filter) {
            @defer (on immediate) {
                <app-table-filter-list
                    [selText] = "selText"
                    [lang] = "lang"
                    [layer] = "currentlySelectedActionViewItem?.originalData?.metadataLayer ?? null"
                    [PXWebConfig] = "currentlySelectedActionViewItem?.originalData?.metadataLayer?.option?.pxWeb"
                    style="display: contents;"
                > <!--style="display: contents;" Is so that it can scroll itself when the height of this component goes out of viewport.-->
                </app-table-filter-list>
            }
        }
        @if (currentViewState === ViewState.mapsLayerList) {
            @defer (on immediate) {
                <app-layer-list
                    [mapLayers]="layerService.mapLayers"
                    [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
                    [layerTree]="layerService.layerTree"
                    [splitMapActive]="displayService.splitMapActive$ | async"
                    [selText]="selText"
                    [lang]="lang"
                    [isBasemapTree]="false"
                    [applicationSettings]="applicationSettings()"
                    [mapObject]="displayService.mapObject || null"
                    [isSecondaryMap]="false"
                    [embedded]="true"
                    style="display: contents;"
                    >
                </app-layer-list>
            }
        }
        @if (currentViewState === ViewState.basemapsLayerList) {
            @defer (on immediate) {
                <app-layer-list
                    [mapLayers]="layerService.mapLayers"
                    [layerStateObs]="[layerService.checkedState$, layerService.legendState$, layerService.layerFilterState$]"
                    [layerTree]="layerService.basemapLayerTree"
                    [splitMapActive]="displayService.splitMapActive$ | async"
                    [selText]="selText"
                    [lang]="lang"
                    [isBasemapTree]="true"
                    [applicationSettings]="applicationSettings()"
                    [mapObject]="displayService.mapObject ?? null"
                    [isSecondaryMap]="false"
                    [embedded]="true"
                    style="display: contents"
                    >
                </app-layer-list>
            }
        }
        @if (currentViewState === ViewState.information) {
            @defer (on immediate) {
                <div class="informationWrapper" [innerHTML]="sanitizedHtml"></div>
            }
        }
        @if (currentViewState === ViewState.chart && currentlySelectedActionViewItem?.originalData?.geoJSONFeature) {
            @defer (on immediate) {
                <app-data-series
                    style="display: contents; overflow-x: hidden;"
                    [feature]="currentlySelectedActionViewItem.originalData.geoJSONFeature"
                    [selText]="selText"
                    [lang]="lang"
                >
                </app-data-series>
            }
        }
    </div>
</div>